<template>
	<div>
		<navpage
			ref="navPage"
			pagename="posts"
			:middle="middle"
			:displayDates="true"
			:displayFilters="true"
			@datepickercreated="setDates()"
		></navpage>
		<div id="content-page">
			<div class="row dynvibeSearch">
				<div class="row dynvibeRow">
					<middlefilter
						v-if="middle"
						ref="middlefilter"
						@changefilters="prepareParameters($event)"
						:displayCheckBoxesFilter="false"
						:displayCheckBoxesMastertag="true"
					></middlefilter>
					<div id="dynvibeSearchFiltersAdvanced" class="col-lg-4">
						<input
							v-if="!highlight && !middle"
							v-model="searchInput"
							placeholder="SEARCH FOR..."
							type="text"
							@keyup.enter="searchPost()"
						/>
						<select
							v-if="highlight && !middle"
							v-model="segment"
							class="listSegments dynvibeListSegments"
							@change="selectSegment()"
						>
							<option value>Segments</option>
							<option v-for="(segment, index) in segments" :value="segment" v-bind:key="index">
								{{ segment }}
							</option>
						</select>
						<select v-model="category" class="listMastertag dynvibeListCategories" @change="selectCategories()">
							<option value>Categories</option>
							<option v-for="category in categories" v-bind:key="category" :value="category">
								{{ category }}
							</option>
						</select>
						<select v-model="subcategory" class="listMastertag dynvibeListSubcategories" @change="selectSubcategories()">
							<option value>Subcategories</option>
							<option v-for="subcategory in subcategories" v-bind:key="subcategory" :value="subcategory">
								{{ subcategory }}
							</option>
						</select>
						<select v-model="mastertag" class="listMastertag dynvibeListMastertags" @change="selectMastertags()">
							<option value>Mastertags</option>
							<option v-for="mastertag in mastertags" v-bind:key="mastertag" :value="mastertag">
								{{ mastertag }}
							</option>
						</select>
						<select v-if="highlight" v-model="title" @change="selectTitle()">
							<option value>Title</option>
							<option v-for="title in titles" :value="title" v-bind:key="title">
								{{ title }}
							</option>
						</select>
						<button v-if="!highlight" class="dynvibeAdvancedSearch" @click="advancedSearch()">Advanced search</button>

						<button v-if="middle" class="dynvibeMtListQuery" @click="showMtListQuery()">Mastertags List Query</button>
						<br />
						<button v-if="middle" class="dynvibePostsBy" @click="postsBy('colors')">Posts by color</button>
						<button v-if="middle" class="dynvibePostsBy" @click="postsBy('objects')">Posts by objects</button>
						<span v-if="!highlight" class="dynvibeSearchInputResetFilters" title="Reset filters" @click="resetFilters()"
							>Reset Filters</span
						>
						<div class="row dynvibeRow" id="dynvibeMtListQueryWC" style="margin-top: 15px; margin-bottom: 15px">
							<div class="col-lg-12">
								<dynvibewordcloud
									v-show="mtListQuery"
									ref="mastertagsListQuery"
									title="Mastertags List Query"
									axios="mastertagsListQuery"
									:clickable="false"
								></dynvibewordcloud>
							</div>
						</div>
					</div>
				</div>
			</div>
			<advancedfilters
				ref="advancedfilters"
				v-show="showModal"
				:mastertags="allMastertags"
				@applyadvancedfilter="applyAdvancedFilters($event)"
				@closemodal="showModal = false"
			></advancedfilters>
			<highlightedit
				v-if="highlight"
				:prop-titles="titles"
				ref="highlightEdit"
				@refreshtitles="refreshTitles"
				@reloadposts="loadComponent"
			></highlightedit>
			<perpagesort v-if="!middle" :size="true" @changesort="changeSortPage" @changerange="changeRangePage"></perpagesort>
			<div v-if="!highlight && !noData" class="row dynvibeRow" style="margin-top: 20px">
				<div class="col-lg-3 col-xs-12">
					<div class="dynvibeBox" style="min-height: 100px">
						<span style="font-size: 16px; font-weight: 700; color: #23056b; text-transform: uppercase">Number of profiles</span>
						<br />
						<span class="dynvibeProfilesDetailsValue">{{ nbProfiles }}</span>
					</div>
				</div>
				<div class="col-lg-4 col-xs-12">
					<div class="dynvibeBox" style="min-height: 100px">
						<span style="font-size: 16px; font-weight: 700; color: #ef402e; text-transform: uppercase">Number of posts</span>
						<br />
						<span class="dynvibeProfilesDetailsValue">{{ nbPosts }}</span>
						<button
							v-if="middle"
							class="dynvibeMassiveActionPosts dynvibeButton"
							style="float: right; margin-left: 10px"
							@click="dynvibeMassiveActionPosts()"
						>
							Posts actions
						</button>
						<button
							v-if="middle"
							class="dynvibeMassiveActionPosts dynvibeButton"
							style="float: right"
							@click="selectAllStories()"
						>
							Select All Stories
						</button>
					</div>
				</div>
				<div v-if="!middle" class="col-lg-6 col-xs-12">
					<div class="dynvibeBox" style="min-height: 100px">
						<span style="font-size: 16px; font-weight: 700; color: #33d1cd; text-transform: uppercase">Latest</span>
						<br />
						<span class="dynvibeProfilesDetailsValue">{{ latestDate }}</span>
					</div>
				</div>
			</div>

			<div v-if="!middle && highlight && !noData" class="row dynvibeRow" style="margin-top: 20px">
				<div class="col-lg-4">
					<div class="dynvibeBox" style="min-height: 100px">
						<span style="font-size: 16px; font-weight: 700; color: #ef402e; text-transform: uppercase"
							>Number of highlighted posts</span
						>
						<br />
						<span class="dynvibeProfilesDetailsValue">{{ nbPosts }}</span>
					</div>
				</div>
			</div>

			<div v-if="!noData" class="row pagination">
				<div class="col-lg-12">
					<div style="float: right; margin-top: 10px">
						<pagination v-if="page >= 0" :page="page" :page-max="pageMax" @changepage="changePostPage($event)"></pagination>
					</div>
				</div>
			</div>
			<div class="row dynvibeRow">
				<div class="col-lg-12 dynvibeListPosts dynvibeBox" style="margin: 10px 0">
					<div v-if="loading" class="dynvibeLoading"></div>
					<div v-else-if="!noData && priority !== 'authors'">
						<bigstory
							v-for="(post, id) in posts"
							:ref="'story-' + id"
							:key="id"
							:post="post"
							:post_id="id"
							:middle="middle"
							:checkedallstories="checkedallstories"
							:checkedstoriesfromchild="checkedStoriesFromChild"
							:includetohighlight="includeToHighlight"
							:searchtohighlight="searchToHighlight"
							:editrule="true"
							@listcheckedmt="listCheckedMtParent"
							@buttonify="buttonify(post)"
							@editprofile="editProfile($event)"
						></bigstory>
					</div>
					<div v-else-if="!noData && priority === 'authors'">
						<div
							v-for="profileId in profiles"
							:key="profileId"
							class="col-xs-12 dynvibeStory"
							style="padding-bottom: 0; padding-top: 0"
						>
							<div class="col-xs-2" style="position: sticky; top: 0">
								<div style="padding: 15px 0">
									<span
										v-if="middle"
										class="dynvibeStoryInfoUsername"
										data-action="Edit"
										title="Edit"
										@click="editProfile(profileId)"
									>
										<span class="dynvibeTableActions dynvibeTableActionsEdit dynvibeModalAuthor">
											{{ getProfile(profileId, "profile_name") }}
										</span>
									</span>
									<p v-else style="margin-bottom: 0">
										Author n°
										<span style="font-weight: 500">
											{{ from + index + 1 }}
										</span>
									</p>
									<p v-if="!highlight" style="font-style: italic">
										(
										{{ getProfile(profileId, "total") }}
										posts)
									</p>

									<fiche :idprofile="profileId" :middle="middle"></fiche>

									<p v-if="getProfile(profileId, 'total') > 5 || highlight">
										<span @click="viewAuthor(profileId)" class="morePostByAuthor" :id="profileId">View all posts</span>
									</p>
									<div v-if="resultsProfile != undefined && resultsProfile[profileId] != undefined">
										<p
											style="min-height: 0"
											v-if="
												getProfile(profileId, 'profile_segment') != undefined &&
												getProfile(profileId, 'profile_segment').length > 0
											"
										>
											<span
												v-for="(segment, index2) in getProfile(profileId, 'profile_segment')"
												:key="index2"
												class="dynvibePostSegment"
												style="margin-bottom: 5px; font-size: 0.9em; width: 100%"
												>{{ segment }}</span
											>
										</p>
									</div>
								</div>
							</div>

							<div v-if="!noData" class="col-xs-10" style="border-left: 1px solid #e6e6e6; padding-left: 0; padding-right: 0">
								<authorstory
									:ref="'story-' + post._id"
									v-for="(post, postId) in posts[profileId]['posts']"
									:key="postId"
									:post_id="postId"
									:post="post"
									:middle="middle"
									:includetohighlight="includeToHighlight"
									:searchtohighlight="searchToHighlight"
								></authorstory>
							</div>
						</div>
					</div>
					<div v-if="!loading && noData" class="noData">
						<p>No Data to display</p>
					</div>
				</div>
			</div>

			<div v-if="!noData" class="row pagination">
				<div class="col-lg-12">
					<div style="float: right; margin-top: 10px">
						<pagination v-if="page >= 0" :page="page" :page-max="pageMax" @changepage="changePostPage($event)"></pagination>
					</div>
				</div>
			</div>
			<dynvibegraphdetails v-show="showGraphDetails" ref="graphDetailsStory" :middle="middle"></dynvibegraphdetails>

			<transition name="modal">
				<div
					v-show="showModalProfiles"
					class="modal-mask"
					tabindex="-1"
					role="dialog"
					aria-labelledby
					aria-hidden="true"
					style="display: block"
					@click="closeModal()"
				>
					<div class="modal-dialog modal-lg">
						<div class="modal-content" @click.stop>
							<div class="modal-header">
								<div class="col-lg-12 dynvibeTitleBox" style="padding-bottom: 10px; margin-bottom: 0">
									<h5 class="modal-title" id="dynvibeGraphDetailsTitle">
										Edit Profiles
										<button type="button" class="close" @click="closeModal()" style="outline: 0">
											<span aria-hidden="true">
												<i class="icon-x"></i>
											</span>
										</button>
									</h5>
								</div>
							</div>
							<div class="modal-body">
								<div class="row dynvibeModalRowForm">
									<div class="col-lg-12">
										<label>Status</label>
									</div>
									<div class="col-lg-12">
										<input
											type="radio"
											id="dynvibeInputNone"
											name="dynvibeAuthorsPublicPrivate"
											v-model="status"
											value="noChange"
											:checked="status == 'noChange'"
										/>
										<label for="dynvibeInputNone" style="cursor: pointer">No change</label>
									</div>
									<div class="col-lg-12">
										<input
											type="radio"
											id="dynvibeInputPublic"
											name="dynvibeAuthorsPublicPrivate"
											v-model="status"
											value="true"
											:checked="status == 'true'"
										/>
										<label for="dynvibeInputPublic" style="cursor: pointer">Public</label>
									</div>
									<div class="col-lg-12">
										<input
											type="radio"
											id="dynvibeInputPrivate"
											name="dynvibeAuthorsPublicPrivate"
											v-model="status"
											value="false"
											:checked="status == 'false'"
										/>
										<label for="dynvibeInputPrivate" style="cursor: pointer">Private</label>
									</div>
								</div>
								<hr />
								<div class="row dynvibeModalRowForm">
									<div class="col-lg-12">
										<label>Segments</label>
									</div>

									<div v-for="segment in segmentsMiddle" :key="segment._source.label">
										<div class="col-lg-6">
											<div class="dynvibeAuthorsSegment">
												<input
													class="dynvibeAuthorsSegmentsinput dynvibeAuthorsSegmentsAdd"
													name="authorsSegmentsAdd"
													type="checkbox"
													:checked="allHave.includes(segment._source.label)"
													@change="isChanged(segment._source.label, 'allHave')"
													:value="segment._source.label"
													title="Add"
												/>
												<input
													class="dynvibeAuthorsSegmentsinput dynvibeAuthorsSegmentsDelete"
													name="authorsSegmentsDelete"
													:checked="noneHave.includes(segment._source.label)"
													@change="isChanged(segment._source.label, 'noneHave')"
													type="checkbox"
													:value="segment._source.label"
													title="Remove"
												/>
												<label style="padding-left: 10px">{{ segment._source.label }}</label>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="modal-footer">
								<button
									@click="saveMassiveProfiles()"
									class="btn-success dynvibeModalFooterBtn dynvibeModifyAuthorsFooterBtn"
								>
									Apply
								</button>
								<button @click="closeModal()" class="btn-danger dynvibeModalFooterBtn dynvibeModifyAuthorsFooterBtn">
									Cancel
								</button>
							</div>
						</div>
					</div>
				</div>
			</transition>
			<div v-if="showModalPosts">
				<transition name="modal">
					<div class="modal-mask" @click="closeModal()">
						<div class="modal-dialog modal-lg">
							<div class="modal-content" @click.stop>
								<div class="modal-header">
									<div class="col-lg-12 dynvibeTitleBox" style="padding-bottom: 10px; margin-bottom: 0">
										<h5 class="modal-title" id="dynvibeGraphDetailsTitle">
											Add a Mastertag to selected stories
											<button type="button" class="close" @click="showModalPosts = false" style="outline: 0">
												<span aria-hidden="true">
													<i class="icon-x"></i>
												</span>
											</button>
										</h5>
									</div>
								</div>
								<div class="modal-body">
									<div class="row dynvibeRow">
										<div class="col-lg-12">
											<div class="dynvibeBox" style="min-height: 150px">
												<div class="col-lg-12 dynvibeModalPostsActions">
													<div class="col-lg-3">
														<select
															v-model="catselected"
															id="dynvibeListCategoriesPostsAction"
															class="listMastertag dynvibeListCategories dynvibeModalPostInput"
															@change="listCatPosts($event, 'cat')"
														>
															<option value>Categories</option>
															<option v-for="category in listCat" :key="category" :value="category">
																{{ category }}
															</option>
														</select>
													</div>
												</div>
												<div class="col-lg-12 dynvibeModalPostsActions">
													<div class="col-lg-3">
														<select
															v-model="subcatselected"
															id="dynvibeListSubcategoriesPostsAction"
															class="listMastertag dynvibeListSubcategories dynvibeModalPostInput"
															@change="listCatPosts($event, 'subcat')"
														>
															<option value>Subcategories</option>
															<option
																v-for="subcategory in listSubCat"
																:key="subcategory"
																:value="subcategory"
															>
																{{ subcategory }}
															</option>
														</select>
													</div>
												</div>
												<div class="col-lg-12 dynvibeModalPostsActions">
													<div class="col-lg-3">
														<select
															v-model="mtselected"
															id="dynvibeListMastertagsPostsAction"
															class="listMastertag dynvibeListMastertags dynvibeModalPostInput"
														>
															<option value>Mastertags</option>
															<option v-for="mastertag in listMt" :key="mastertag" :value="mastertag">
																{{ mastertag }}
															</option>
														</select>
													</div>
													<div class="col-lg-7">
														<div
															class="dynvibeModalMastertagsDelete"
															v-if="
																flattenObject(checkedMtFromChild).filter((v, i, a) => a.indexOf(v) === i)
																	.length > 0
															"
														>
															<div class="col-lg-12 dynvibeTitleBox">
																<h5>Mastertags in selected stories</h5>
															</div>
															<div
																class="dynvibeModalMastertagDelete"
																v-for="(item, index) in flattenObject(checkedMtFromChild).filter(
																	(v, i, a) => a.indexOf(v) === i
																)"
																:key="index"
															>
																<span>{{ item }}</span>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="modal-footer">
									<button class="btn-success dynvibeModalPostsActionsFooterBtn" @click="saveMassivePosts()">Add</button>
									<button class="btn-primary dynvibeModalPostsActionsFooterBtn" @click="removeMassivePosts()">
										Delete
									</button>
									<button @click="showModalPosts = false" class="btn-danger dynvibeModalPostsActionsFooterBtn">
										Cancel
									</button>
								</div>
							</div>
						</div>
					</div>
				</transition>
			</div>
			<transition name="modal">
				<div
					v-show="showModalRules"
					class="modal-mask"
					tabindex="-1"
					role="dialog"
					aria-hidden="true"
					style="display: block"
					@click="closeModal()"
				>
					<!-- @click="closeModal()" -->
					<div class="modal-dialog modal-lg">
						<div class="modal-content" @click.stop>
							<div class="modal-header">
								<div class="col-lg-12 dynvibeTitleBox" style="padding-bottom: 10px; margin-bottom: 0">
									<h5 class="modal-title" id="dynvibeGraphDetailsTitle">
										Create Rule
										<button
											type="button"
											@click="closeModal()"
											class="close"
											data-dismiss="modal"
											aria-label="Close"
											style="outline: 0"
										>
											<span aria-hidden="true">
												<i class="icon-x"></i>
											</span>
										</button>
									</h5>
								</div>
							</div>
							<div class="modal-body">
								<div class="row dynvibeRow">
									<div class="col-lg-12">
										<createrules ref="createrules" :textToButton="textToButton"></createrules>
									</div>
								</div>
							</div>
							<div class="modal-footer">
								<button class="btn-success createRuleFromPost saveRuleFromPost" @click="saveRuleFromPost">
									Create Rule
								</button>
								<button @click="closeModal()" class="btn-danger createRuleFromPost">Cancel</button>
							</div>
						</div>
					</div>
				</div>
			</transition>
			<div>
				<profilesedit ref="profilesedit"></profilesedit>
			</div>
			<div>
				<mediacontent ref="mediacontent" :filters="postOptions"></mediacontent>
			</div>
			<confirm ref="confirm" :color="confirmColor" :title="confirmTitle" :type="confirmType" @answerconfirm="treatConfirm($event)">
				<template v-slot:confirm-body>
					{{ confirmMessage }}
					<div v-if="inputConfirm">
						<input v-model="confirmAdd" autofocus class="form-control" type="text" />
					</div>
				</template>
			</confirm>
		</div>
		<slot name="page"></slot>
	</div>
</template>

<script>
import navpage from "@/components/globalVue/Nav.vue";
import authorstory from "@/components/posts/authorStory.vue";
import bigstory from "@/components/posts/bigStory.vue";
import pagination from "@/components/globalVue/Pagination.vue";
import perpagesort from "@/components/globalVue/perpageSort.vue";
import fiche from "@/components/posts/fiche.vue";
import advancedfilters from "@/components/posts/advancedfilters.vue";
import highlightedit from "@/components/highlight/highlightEdit.vue";
import dynvibegraphdetails from "@/components/vueCharts/GraphDetails.vue";
import middlefilter from "@/components/globalVue/MiddleFilter.vue";

import confirm from "@/components/globalVue/Confirm.vue";
import profilesedit from "@/components/profiles/ProfilesEdit.vue";
import createrules from "@/components/globalVue/createRules.vue";
import mediacontent from "@/components/globalVue/MediaContent.vue";

export default {
	name: "postpage",
	props: {
		middle: {
			type: Boolean,
			default: true,
		},
		highlight: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			noData: false,
			posts: {},
			loading: true,
			page: 0,
			pageMax: 50,
			profiles: 0,
			latestDate: "",
			nbPosts: 0,
			priority: "posts",
			from: 0,
			resultsProfile: {},
			nbProfiles: 0,
			titlesAdded: {},
			categories: [],
			subcategories: [],
			mastertags: [],
			segments: [],
			segmentsMiddle: [],
			titles: [],
			searchInput: "",
			category: "",
			subcategory: "",
			mastertag: "",
			segment: "",
			title: "",
			showModal: false,
			showModalRules: false,
			postOptions: {
				page: 0,
				middle: this.middle,
			},
			//advancedFiltersOptions: {},
			showGraphDetails: false,
			includeToHighlight: [],
			searchToHighlight: null,
			showModalProfiles: false,
			allHave: [],
			noneHave: [],
			status: "",
			showModalPosts: false,
			listCat: [],
			listSubCat: [],
			listMt: [],
			checkedMt: false,
			checkedMtFromChild: [],
			checkedStoriesFromChild: [],
			catselected: "",
			subcatselected: "",
			mtselected: "",
			mtListQuery: false,
			checkedallstories: false,
			inputConfirm: false,
			confirmColor: "",
			confirmTitle: "",
			confirmType: "",
			confirmMessage: "",
			confirmAdd: "",
			allMastertags: [],
			//mastertags:"",
			group1: "",
			group2: "",
			textToButton: [],
			rowSynonym1: [],
			rowSynonym2: [],
			showSyn1: false,
			showSyn2: false,
			listCheckedMt: [],
			story_is_checked: false,
			selectedMt: "",
			firstSyn1: "",
			firstSyn2: "",
			syn1Showed: false,
			syn2Showed: false,
		};
	},
	components: {
		navpage: navpage,
		authorstory: authorstory,
		bigstory: bigstory,
		pagination: pagination,
		perpagesort: perpagesort,
		fiche: fiche,
		advancedfilters: advancedfilters,
		highlightedit: highlightedit,
		dynvibegraphdetails: dynvibegraphdetails,
		middlefilter: middlefilter,
		// dynvibewordcloud: dynvibewordcloud,
		confirm: confirm,
		profilesedit: profilesedit,
		createrules: createrules,
		mediacontent: mediacontent,
	},
	created() {
		this.$axios.get(this.$backendUrl + "postsVue").then((response) => {
			this.mastertags = response.data.mastertags;
			this.categories = response.data.categories;
			this.subcategories = response.data.subcategories;
			this.segments = response.data.segments;
			this.allMastertags = response.data.mastertags;
		});
	},
	methods: {
		loadComponent(parameters) {
			console.log(parameters);
			if (!this.postOptions.sort) {
				this.postOptions.sort = {
					field: "post_date",
					order: "desc",
				};
			}
			this.priority = this.postOptions.sort.field === "authors" ? "authors" : "posts";

			this.loading = true;
			console.log(this.$store.getters.parameters);
			let finalParameters = {
				parameters: this.$store.getters.parameters,
				data: this.postOptions,
			};
			if (this.highlight === true) {
				this.getData("highlightsPosts", finalParameters, "indices");
			} else {
				this.getData("listPosts", finalParameters);
				if (this.middle === true && this.mtListQuery === true) {
					let paramsWc = this.$store.getters.parameters;
					let options = this.postOptions;
					let loadWc = Object.assign(paramsWc, options);
					this.$refs.mastertagsListQuery.loadComponent(loadWc);
					delete this.$storegetters.parameters.page;
				}
			}
		},
		treatResponse(response) {
			this.loading = false;
			if (!this.category && !this.subcategory && !this.mastertag) {
				this.categories = response.data.categories;
				this.subcategories = response.data.subcategories;
				this.mastertags = response.data.mastertags;
				this.allMastertags = response.data.mastertags;
			}
			if (this.highlight && !this.segment && !this.title) {
				this.segments = response.data.segments;
				this.titles = response.data.titles;
			}
			if (response.data.totalPosts > 0) {
				this.noData = false;
				this.posts = response.data.resultsPosts;

				this.profiles = response.data.profiles;
				this.latestDate = response.data.latestDate;
				this.nbPosts = response.data.totalPosts;
			} else {
				this.nbPosts = 0;
				this.noData = true;
				this.latestDate = "";
			}
			this.from = response.data.from != undefined ? response.data.from : 0;

			this.resultsProfile = response.data.resultsProfile;
			this.pageMax = response.data.pageMax;
			this.page = parseInt(response.data.page);

			this.nbProfiles = this.postOptions.sort.field === "authors" ? response.data.totalProfiles : this.profiles;

			if (response.data.titlesAdded) {
				this.titlesAdded = response.data.titlesAdded;
			}

			if (this.postOptions.includeWords && this.postOptions.includeWords.length) {
				this.highlightIncludeWords();
			}

			if (this.postOptions.search) {
				this.searchToHighlight = this.postOptions.search;
			} else if (this.postOptions.search == "") {
				this.searchToHighlight = "";
			}
			this.segmentsMiddle = response.data.segmentsMiddle;
		},
		prepareParameters(event) {
			let val = event.profiles;
			let mastertagged = event.mastertagged;

			let oldMastertags = this.postOptions.mastertags;
			let oldExcludeWords = this.postOptions.excludeWords;
			let oldIncludeWords = this.postOptions.includeWords;

			this.postOptions = {
				page: 0,
				middle: this.middle,
				mastertags: oldMastertags,
				excludeWords: oldExcludeWords,
				includeWords: oldIncludeWords,
			};
			this.postOptions.type = "Posts";
			this.postOptions.sort = {
				field: val.sort.field,
				order: val.sort.order,
			};

			if (mastertagged && mastertagged !== "All") {
				this.postOptions.mastertagged = mastertagged;
			}

			this.category !== "" ? (this.postOptions.category = this.category) : false;
			this.subcategory !== "" ? (this.postOptions.subcategory = this.subcategory) : false;
			this.mastertag !== "" ? (this.postOptions.mastertag = this.mastertag) : false;

			val.search !== "" ? (this.postOptions.search = val.search) : false;
			val.panel !== "" ? (this.postOptions.panel = val.panel) : false;
			val.segment !== "" ? (this.postOptions.segment = val.segment) : false;
			/*if (val.sort.date.order == "authors") {
				this.postOptions.orderBy = "authors";
				delete this.postOptions.sort;
			} else {
				this.postOptions.orderBy = val.sort.date.order;
				delete this.postOptions.sort;
			}*/
			this.postOptions.size = val.size !== "" ? parseInt(val.size) : 20;

			this.postOptions.impact_score = {
				gt: val.impact_score_min,
				lt: val.impact_score_max,
			};
			val.impact_score_max == "" ? delete this.postOptions.impact_score.lt : false;
			val.impact_score_min == "" ? delete this.postOptions.impact_score.gt : false;

			this.postOptions.is_checked = val.is_checked;
			this.postOptions.is_active = val.is_active;

			val.no_segment == true ? (this.postOptions.no_segment = true) : false;
			val.no_source == true ? (this.postOptions.no_source = true) : false;
			val.private == true ? (this.postOptions.private = true) : false;
			val.public == true ? (this.postOptions.public = true) : false;

			this.postOptions.is_checked && this.postOptions.is_checked.length < 1 ? delete this.postOptions.is_checked : false;
			this.postOptions.is_active && this.postOptions.is_active.length < 1 ? delete this.postOptions.is_active : false;

			this.loadComponent();
		},
		setDates() {
			// TODO set date to 3 month by default
			this.$refs.navPage.setDates(this.$moment().subtract(3, "month").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD"));
		},
		highlightIncludeWords() {
			let includeWords = [];
			this.postOptions.includeWords.forEach((words) => {
				includeWords = includeWords.concat(words);
			});
			let wordsMulti = [];

			includeWords = includeWords.map((word) => {
				let formattedWord;
				if (word.substr(0, 1) == '"' && word.substr(-1, 1) == '"') {
					formattedWord = word
						.toLowerCase()
						.normalize("NFD")
						.replace(/[\u0300-\u036f]/g, "");
				} else {
					formattedWord = word
						.toLowerCase()
						.replace(/"/g, "")
						.normalize("NFD")
						.replace(/[\u0300-\u036f]/g, "");
				}
				if (word.indexOf(" ") > 0) {
					let wordMulti = word.replace(/ /g, "");
					wordsMulti.push(wordMulti);
				}
				return formattedWord;
			});

			includeWords = includeWords.concat(wordsMulti);

			this.includeToHighlight = includeWords;
		},
		viewAuthor(idProfile) {
			let middleProfile = false;
			if (this.middle === true) {
				middleProfile = true;
			}
			this.$refs.graphDetailsStory.getDataStory(idProfile, middleProfile);
			this.showGraphDetails = true;
		},
		changePostPage(page) {
			this.checkedMtFromChild = [];
			this.checkedStoriesFromChild = [];
			this.checkedallstories = false;
			this.postOptions.page = page;
			this.loadComponent();
		},
		changeSortPage(sort) {
			this.postOptions.page = 0;
			this.postOptions.sort.field = sort;
			this.priority = this.postOptions.sort.field === "authors" ? "authors" : "posts";
			this.loadComponent();
		},
		changeRangePage(range) {
			this.postOptions.page = 0;
			this.postOptions.size = range;
			this.loadComponent();
		},
		searchPost() {
			this.postOptions.page = 0;
			this.postOptions.search = this.searchInput.replace(/[\u0300-\u036f]/g, "");
			if (this.searchInput.length === 0) {
				delete this.postOptions.search;
			}
			this.loadComponent();
		},
		selectCategories() {
			delete this.postOptions.subcategory;
			delete this.postOptions.mastertag;
			this.subcategory = "";
			this.mastertag = "";
			this.subcategories = [];
			this.mastertags = [];
			this.postOptions.page = 0;

			let params = {};
			if (this.category) {
				params = {
					label: this.category,
					type: "cat",
				};
			}
			this.$axios
				.get(this.$backendUrl + "getCategories", {
					params: params,
					paramsSerializer: function (params) {
						return this.$Qs.stringify(params, {
							arrayFormat: "brackets",
						});
					},
				})
				.then((response) => {
					this.subcategories = response.data.subcategories;

					// bugfix : with local database -> multiple times the same mastertags with food category
					let alreadyThere = [];
					this.mastertags = response.data.mastertags.filter((mastertag) => {
						if (!alreadyThere.includes(mastertag)) {
							alreadyThere.push(mastertag);
							return true;
						} else {
							return false;
						}
					});
				});
			if (this.category) {
				this.postOptions.category = this.category;
			} else {
				delete this.postOptions.category;
			}
			this.loadComponent();
		},
		selectSubcategories() {
			delete this.postOptions.mastertag;
			this.mastertag = "";
			this.postOptions.page = 0;
			if (this.subcategory) {
				let params = {
					label: this.subcategory,
					type: "subcat",
				};
				this.$axios
					.get(this.$backendUrl + "getCategories", {
						params: params,
						paramsSerializer: function (params) {
							return this.$Qs.stringify(params, {
								arrayFormat: "brackets",
							});
						},
					})
					.then((response) => {
						this.mastertags = response.data.mastertags;
					});
				this.postOptions.subcategory = this.subcategory;
			} else {
				if (this.category) {
					this.selectCategories();
				}
				delete this.postOptions.subcategory;
			}
			this.loadComponent();
		},
		selectMastertags() {
			this.postOptions.page = 0;
			if (this.mastertag) {
				this.postOptions.mastertag = this.mastertag;
			} else {
				if (this.subcategory) {
					this.selectSubcategories();
				} else if (this.category) {
					this.selectCategories();
				}
				delete this.postOptions.mastertag;
			}
			this.loadComponent();
		},
		selectSegment() {
			if (this.segment) {
				this.postOptions.segment = this.segment;
				this.postOptions.sizehashtags = 100;
			} else {
				delete this.postOptions.segment;
				delete this.postOptions.sizehashtags;
			}
			this.loadComponent();
		},
		selectTitle() {
			if (this.title) {
				this.postOptions.highlightTitle = this.title;
			} else {
				delete this.postOptions.highlightTitle;
			}
			this.loadComponent();
		},
		advancedSearch() {
			this.showModal = true;
		},
		resetFilters() {
			this.$refs.advancedfilters.resetFilters();
			this.middle === true ? this.$refs.middlefilter.resetFilters(true) : false;
			this.$axios.get(this.$backendUrl + "postsVue").then((response) => {
				this.mastertags = response.data.mastertags;
				this.categories = response.data.categories;
				this.subcategories = response.data.subcategories;
				this.segments = response.data.segments;
				this.allMastertags = response.data.mastertags;
			});
			this.category = "";
			this.subcategory = "";
			this.mastertag = "";
			this.searchToHighlight = null;
			this.includeToHighlight = [];
			this.postOptions = {
				page: 0,
			};
			this.loadComponent();
		},

		applyAdvancedFilters(tmp) {
			this.postOptions.page = 0;
			this.postOptions.mastertags = tmp.mastertags;
			this.postOptions.excludeWords = tmp.excludeWords;
			this.postOptions.includeWords = tmp.includeWords;
			this.loadComponent();
			this.showModal = false;
		},
		refreshTitles(newTitles) {
			this.titles = newTitles;
			this.title = "";
			delete this.postOptions.highlightTitle;
		},
		dynvibeMassiveActionProfiles() {
			this.showModal = false;
			this.allHave = [];
			this.noneHave = [];
			this.status = "";
			let parameters = this.$storegetters.parameters;
			//let newlet = merge(parameters,postoptions)
			let params = { parameters: parameters, data: this.postOptions };
			this.$axios
				.post(this.$backendUrl + "loadInfoMassiveProfiles", this.$Qs.stringify(params, { arrayFormat: "brackets" }))
				.then((response) => {
					this.allHave = response.data.allHave;
					this.noneHave = response.data.noneHave;
					this.status = response.data.status;
				});

			this.showModalProfiles = true;
		},
		closeModal() {
			this.showModalProfiles = false;
			this.showModalPosts = false;
			this.showModalRules = false;
			this.catselected = "";
			this.subcatselected = "";
			this.mtselected = "";
		},
		isChanged(label, group) {
			if (group == "allHave") {
				if (!this.allHave.includes(label) && !this.noneHave.includes(label)) {
					this.allHave.push(label);
				} else if (this.allHave.includes(label) && !this.noneHave.includes(label)) {
					let filtered = this.allHave.filter(function (value) {
						return value != label;
					});
					this.allHave = filtered;
				} else {
					let filtered = this.noneHave.filter(function (value) {
						return value != label;
					});
					this.noneHave = filtered;
					this.allHave.push(label);
				}
			} else if (group == "noneHave") {
				if (!this.noneHave.includes(label) && !this.allHave.includes(label)) {
					this.noneHave.push(label);
				} else if (this.noneHave.includes(label) && !this.allHave.includes(label)) {
					let filtered = this.noneHave.filter(function (value) {
						return value != label;
					});
					this.noneHave = filtered;
				} else {
					let filtered = this.allHave.filter(function (value) {
						return value != label;
					});
					this.allHave = filtered;
					this.noneHave.push(label);
				}
			}
		},
		saveMassiveProfiles() {
			this.confirmLoadingModal("open");
			let publicOrPrivate = this.status;
			let checkedSegmentsAdd = this.allHave;
			let checkedSegmentsDelete = this.noneHave;
			let parameters = this.$storegetters.parameters;
			let data_temp = { news: {}, adds: {}, removes: {} };

			// let data = Object.assign(data_temp, parameters);

			if (publicOrPrivate !== "noChange") {
				data_temp.news.public = publicOrPrivate;
			}
			if (0 < checkedSegmentsAdd.length) {
				data_temp.adds.segment = checkedSegmentsAdd;
			}
			if (0 < checkedSegmentsDelete.length) {
				data_temp.removes.segment = checkedSegmentsDelete;
			}
			let params = {
				parameters: parameters,
				data: this.postOptions,
				data_temp: data_temp,
			};
			this.$axios
				.post(this.$backendUrl + "massiveProfiles", this.$Qs.stringify(params))
				.then((response) => {
					if (response.data.isOk) {
						this.confirmSuccessModal("Profile update succeeded.");
					} else {
						this.confirmErrorModal("Profile update failed.");
						return false;
					}
					this.showModalProfiles = false;
				})
				.catch(() => {
					this.confirmErrorModal("Profile update failed.");
					this.showModalProfiles = false;
				});
		},
		dynvibeMassiveActionPosts() {
			//let parameters = this.$storegetters.parameters;
			this.listCat = this.categories;
			this.listSubCat = this.subcategories;
			this.listMt = this.allMastertags;
			if (Object.keys(this.checkedMtFromChild).length === 0) {
				this.confirmErrorModal("No post selected");
				return;
			}
			this.showModalPosts = true;
		},
		listCatPosts(event, type) {
			let val = event.target.value;
			if (val != "") {
				let params = { label: val, type: type };
				this.$axios
					.get(this.$backendUrl + "getCategory", {
						params: params,
						paramsSerializer: function (params) {
							return this.$Qs.stringify(params, {
								arrayFormat: "brackets",
							});
						},
					})
					.then((response) => {
						if (type == "cat") {
							this.listSubCat = response.data.category.subcategories;
							this.listMt = response.data.mastertags;
						} else {
							this.listMt = response.data.mastertags;
						}
					});
			} else {
				this.listCat = this.categories;
				this.listSubCat = this.subcategories;
				this.listMt = this.mastertags;
			}
		},
		flattenObject(ob) {
			let toReturn = [];

			for (let i in ob) {
				if (!Object.prototype.hasOwnProperty.call(ob, i)) continue;

				if (typeof ob[i] == "object" && ob[i] !== null) {
					let flatObject = this.flattenObject(ob[i]);
					for (let x in flatObject) {
						if (!Object.prototype.hasOwnProperty.call(flatObject, x)) continue;

						toReturn.push(flatObject[x]);
					}
				} else {
					toReturn[i] = ob[i];
				}
			}
			return toReturn;
		},
		listCheckedMtParent({ event, mastertag, storieschecked }) {
			if (event) {
				this.checkedMtFromChild[storieschecked] = [];
				for (const i in mastertag) {
					this.checkedMtFromChild[storieschecked].push(mastertag[i].label);
				}
				this.checkedStoriesFromChild.indexOf(storieschecked) == -1 ? this.checkedStoriesFromChild.push(storieschecked) : "";
			} else if (!event) {
				for (const i in mastertag) {
					this.checkedMtFromChild[storieschecked] && this.checkedMtFromChild[storieschecked].indexOf(mastertag[i].label) != -1
						? this.checkedMtFromChild[storieschecked].splice(
								this.checkedMtFromChild[storieschecked].indexOf(mastertag[i].label),
								1
						  )
						: "";
				}
				this.checkedMtFromChild[storieschecked] && this.checkedMtFromChild[storieschecked].length == 0
					? delete this.checkedMtFromChild[storieschecked]
					: "";
				this.checkedStoriesFromChild.indexOf(storieschecked) != -1
					? this.checkedStoriesFromChild.splice(this.checkedStoriesFromChild.indexOf(storieschecked), 1)
					: "";
			}
		},
		saveMassivePosts() {
			this.confirmLoadingModal("open");
			let mastertag = this.mtselected;
			let stories = this.checkedStoriesFromChild;

			let data = {
				mastertag: mastertag,
				stories: stories,
			};

			if (mastertag && stories.length > 0) {
				this.$axios.post(this.$backendUrl + "updateStories", this.$Qs.stringify(data)).then((response) => {
					if (response.data.return) {
						this.confirmSuccessModal("Posts has been updated.");
						this.loadComponent();
						this.closeModal();
						this.checkedMtFromChild = [];
						this.checkedStoriesFromChild = [];
						this.checkedallstories = false;
					}
				});
			} else {
				if (stories.length == 0) this.confirmErrorModal("No Posts selected");
				else {
					this.confirmErrorModal("Please select a mastertag");
				}
			}
		},
		removeMassivePosts() {
			this.confirmLoadingModal("open");
			let mastertag = this.mtselected;
			let stories = this.checkedStoriesFromChild;
			let checked = this.flattenObject(this.checkedMtFromChild).filter((v, i, a) => a.indexOf(v) === i);
			let data = {
				mastertag: mastertag,
				stories: stories,
			};

			if (mastertag && stories.length > 0 && checked.includes(mastertag)) {
				this.$axios.post(this.$backendUrl + "deleteMastertagStories", this.$Qs.stringify(data)).then((response) => {
					if (response.data.return) {
						this.confirmSuccessModal("Mastertag removed from stories.");
						this.loadComponent();
						this.closeModal();
						this.checkedMtFromChild = [];
						this.checkedStoriesFromChild = [];
						this.checkedallstories = false;
						// this.checkedMtFromChild.splice(this.checkedMtFromChild.indexOf(this.mtselected), 1);
					}
				});
			} else {
				if (stories.length == 0) this.confirmErrorModal("No Posts selected");
				else if (!checked.includes(mastertag)) {
					this.confirmErrorModal("This post doesn't contain your selected mastertag");
				} else {
					this.confirmErrorModal("Please select a mastertag");
				}
			}
		},
		showMtListQuery() {
			if (!this.mtListQuery) {
				this.mtListQuery = true;
				if (this.$refs.mastertagsListQuery) {
					let paramsWc = this.$store.getters.parameters;
					let options = this.postOptions;
					let finalParameters = Object.assign(paramsWc, options);
					this.$refs.mastertagsListQuery.loadComponent(finalParameters);
					delete this.$store.getters.parameters.page;
				}
			} else this.mtListQuery = false;
		},
		postsBy(type) {
			this.$refs.mediacontent.loadModal(type);
		},
		selectAllStories() {
			this.checkedallstories = !this.checkedallstories;
		},
		blur(event, item, index, group) {
			let text = event.target.innerText;
			event.target.innerText = text;
			if (group == 1) {
				this.rowSynonym1[index] = text;
			} else {
				this.rowSynonym2[index] = text;
			}
		},
		addSynonymRow(group) {
			let addRow1 = "";
			if (group == 1) {
				this.rowSynonym1.push(addRow1);
			} else {
				this.rowSynonym2.push(addRow1);
			}
		},
		showSynonyms(group) {
			if (group == 1) {
				if (this.showSyn1 == false) {
					this.showSyn1 = true;
				} else {
					this.showSyn1 = false;
				}
				if (this.syn1Showed == false) {
					this.addSynonymRow(group);
					this.syn1Showed = true;
				}
			} else {
				if (this.showSyn2 == false) {
					this.showSyn2 = true;
				} else {
					this.showSyn2 = false;
				}
				if (this.syn2Showed == false) {
					this.addSynonymRow(group);
					this.syn2Showed = true;
				}
			}
		},
		buttonify(post) {
			this.showModalRules = true;
			this.$refs.createrules.resetFields();
			let txt = post.post_content && post.post_content.title ? post.post_content.title : "";
			txt = txt.replace(/(.)\1{2,}/g, "$1$1");
			txt = txt.replace("'", " ");
			let txtToArray = txt.split(/(\s|.#|")/);

			txtToArray = txtToArray.map((x) => {
				return x.toString().replace(/^([\s]*)|([\s]*)$/g, "");
			});
			txtToArray = txtToArray.filter(function (v) {
				return v !== "";
			});
			txtToArray = txtToArray.filter(function (v) {
				return v !== '"';
			});
			this.group1 = "";
			this.group2 = "";
			this.showSyn1 = this.showSyn2 = false;
			this.syn1Showed = false;
			this.syn2Showed = false;
			this.rowSynonym1 = [];
			this.rowSynonym2 = [];
			this.showModalRules = true;
			this.textToButton = txtToArray;
			//let txt = $('#storyText_' + id).text();
		},
		isCheckedMt(event) {
			let target = event.target;
			this.$emit("storychecked", target);
		},
		saveRuleFromPost() {
			if (!this.$refs.createrules.selectedMt || this.$refs.createrules.selectedMt === "") {
				this.confirmErrorModal("Mastertag empty");
				return;
			}

			let group1 = [];
			let group2 = [];
			let group1trimmed = this.$refs.createrules.group1.trim();
			let group2trimmed = this.$refs.createrules.group2.trim();
			if (group1trimmed != "") {
				this.confirmLoadingModal("open");
				group1.push(group1trimmed);
				group2.push(group2trimmed);

				let synonym1 = this.$refs.createrules.rowSynonym1;
				let synonym2 = this.$refs.createrules.rowSynonym2;
				let synonym1trimmed = synonym1.map((res) => res.trim());
				let synonym2trimmed = synonym2.map((res) => res.trim());
				let synonym1filtered = synonym1trimmed.filter(function (el) {
					return el != "";
				});
				let synonym2filtered = synonym2trimmed.filter(function (el) {
					return el != "";
				});

				group1 = group1.concat(synonym1filtered);
				group2 = group2.concat(synonym2filtered);

				let arrayRules = [];
				arrayRules.push(group1);
				arrayRules.push(group2);
				let rules = [];
				let rule = {
					rule: arrayRules,
					lang: this.$refs.createrules.selectedLanguage,
				};
				rules.push(rule);
				let mastertag = this.$refs.createrules.selectedMt;
				let createrules = this.$refs.createrules;

				let existingMastertag = this.$refs.createrules.existingMastertag;

				let data = {
					mastertag: mastertag,
					rules: rules,
					existingMastertag: existingMastertag,
					addByPost: true,
					twitteraccount: "",
					typemastertag: this.$refs.createrules.filterTagclass,
					subcategories: this.$refs.createrules.filterSubcategories,
				};

				if (mastertag != "") {
					this.$axios
						.post(this.$backendUrl + "updateMastertag", this.$Qs.stringify(data))
						.then((response) => {
							if (response.data.isOk) {
								this.confirmSuccessModal("Mastertag " + mastertag + " has been edited.");
								createrules.selectedMt = "";
								createrules.resetFields();
								this.closeModal();
							}
						})
						.catch(() => {
							this.confirmErrorModal("Mastertag " + mastertag + " has not been edited.");
						});
				} else {
					this.confirmErrorModal("Mastertag empty");
				}
			} else {
				this.confirmErrorModal("Group 1 empty");
			}
		},
		changeRowSynonym(event, index, group) {
			if (group == 1) this.rowSynonym1[index] = event.target;
			else this.rowSynonym2[index] = event.target;
		},
		editProfile(val) {
			this.$refs.profilesedit.loadData(val, true);
		},

		getProfile(profileId, key) {
			let profile = this.posts[profileId];
			if (key === "total") {
				return profile["total"];
			} else {
				let first = Object.keys(profile["posts"])[0];
				return profile["posts"][first][key];
			}
		},
	},
	watch: {
		"$store.getters.parameters": function () {
			this.loadComponent();
		},
	},
};
</script>

<style scoped>
.dynvibeSearch input {
	text-transform: none;
}

.row.pagination {
	display: block;
}

.modal-mask {
	position: fixed;
	overflow-y: scroll;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}
#dynvibeMtListQueryWC {
	margin: 0;
}
.dynvibePostsBy,
.dynvibeSearchInputResetFilters {
	margin-top: 7px;
}
</style>
